import { useQuery } from '@tanstack/react-query';
import { chatApi } from '@data/rest/api';
import { ChatMessage } from '../chatTypes';

export const chatMessageKeys = Object.freeze({
    all: ['chat_messages'] as const,
    byChat: (chatId: number | null) => [...chatMessageKeys.all, chatId] as const,
});

export function useChatMessages(chatId: number | null, enabled: boolean = true) {
    return useQuery({
        queryKey: chatMessageKeys.byChat(chatId),
        queryFn: async (): Promise<ChatMessage[]> => {
            if (chatId === null) {
                return [];
            }
            return chatApi.getAllByChatId(chatId);
        },
        enabled: enabled && chatId !== null,
        staleTime: 0, // Always refetch when switching chats
        // A stale/foreign chat id 404/403s — retrying won't help, so fail fast (still retry transient errors).
        retry: (failureCount, error) => {
            const status = error instanceof Response ? error.status : 0;
            if (status >= 400 && status < 500) return false;
            return failureCount < 2;
        },
    });
}
